import {
    Card,
    CardContent,
    CardHeader,
    Button,
    Divider,
    Typography,
    InputAdornment,
    Link,
    IconButton,
    Unstable_Grid2 as Grid,
} from '@mui/material';
import { FormTextField } from '@/components/HookForm';
import { useForm } from 'react-hook-form';
// import { LoadingButton } from '@/components/common/LoadingButton';

// import flowingLogo from '@/assets/images/logo/flowing_space_logo_signiture.svg'
import flowingLogo from '@/assets/images/logo/flowing_space_logo.png';
import { Helmet } from 'react-helmet-async';
import {
    Lock as LockIcon,
    Visibility as ShowIcon,
    VisibilityOff as HideIcon,
    Password as PasswordIcon,
} from '@mui/icons-material';

import { apiUrls, services } from '@/constant/configure';
import { clearTemporaryToken, getOwnMalls, getToken, setTemporaryToken, signInSession } from '@/services/auth.service';
import { useLocation, useNavigation, useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { dialogOpen } from '@/modules/MuiDialog';
import { checkOpenState } from '@/services/open-mall.service';
import ResetPassword from '@/pages/dialogs/ResetPassword';
import { useTranslation } from 'react-i18next';

import sellerTextLogo from '@/assets/images/logo/seller_text_logo_black.png';

import socialApple from '@/assets/images/sources/social_logo/logo_apple_btn.png';
import socialKakao from '@/assets/images/sources/social_logo/logo_kakao_btn.png';
import socialNaver from '@/assets/images/sources/social_logo/logo_naver_btn.png';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import sellerHookingLogo from '@/assets/images/logo/seller_hooking_logo.png';
import soduBrandMark from '@/assets/sodu/brand-mark.svg';
import soduWordmarkStack from '@/assets/sodu/wordmark-stack.svg';
import qs from 'qs';
import { isFlowingSpaceDomain, isSodomallPartnerDomain } from '@/utils/checkDomain';
import SodomallPartnerLogin from '@/pages/SodomallPartnerLogin';

export default (props: any) => {
    const { t } = useTranslation();
    const form = useForm();
    const {
        handleSubmit,
        getValues,
        watch,
        formState: { isValid, isSubmitting },
        reset,
    } = form; //
    const navigate = useNavigate();

    const [queries] = useSearchParams();
    let refer = queries.get('refer');
    const isSodomallParam = queries.get('sodomall') === 'true';

    // 소도몰 파트너 도메인 또는 쿼리 파라미터인 경우 별도 로그인 페이지 표시
    if (isSodomallPartnerDomain() || isSodomallParam) {
        return <SodomallPartnerLogin {...props} />;
    }
    const [isPassView, setIsPassView] = useState(false);

    const location = useLocation();
    const navigation = useNavigation();

    useEffect(() => {
        let sellerEmail = queries.get('email') || '';
        if (!!sellerEmail) {
            reset({
                email: sellerEmail,
            });
        }
    }, []);

    const signIn = async (data: any) => {
        // //
        try {
            if (!isValid || isSubmitting) return;
            const email = data.email.trim();
            const password = data.password; //
            const session = await signInSession(email, password);
            console.log('here!!');

            // const checkMall
            // const { ownMallList = [] } = await getOwnMalls();
            // console.log('malls', ownMallList);

            toast.success(t('auth.loginSuccess'));

            // !!refer ? navigate(refer) : navigate(`/mall/${session.mallId}`);

            if (!refer) {
                // navigate(`/mall/${session.mallId}`);
                navigate(`/studio/${session.userId}`);
            } else {
                navigate(refer);
            }
        } catch (e: any) {
            console.error(e);

            if (!!e.data?.placeHolder || !!e.placeHolder) {
                toast.error(e.data?.placeHolder || e.placeHolder);
            } else {
                if (e.status === 302) {
                    toast.error(t('auth.accountDeactivated'));

                    return;
                }

                if (e.code === 'not-exist-own-mall') {
                    // toast.error('아직 상점을 개설하지 않은 계정입니다.');

                    const { userId, userSecret } = e.data?.signInInfo || {};

                    console.log('%c test-excepted-login', 'color:red;background-color:yellow;', { userId, userSecret });
                    const { accessToken } = await getToken(userId, userSecret);

                    if (!accessToken) return;
                    const state = await checkOpenState(accessToken);

                    if (!state) {
                        dialogOpen({
                            title: '아직 상점을 개설하지 않으셨네요!',
                            message: '본인만의 상점을 개설하시겠어요?',
                            confirmText: '지금 신청하러 가기',
                            onConfirmed: async () => {
                                try {
                                    // const {userId, userSecret} = e.data?.signInInfo || {};
                                    // const {accessToken} = await getToken(userId, userSecret);
                                    setTemporaryToken(accessToken);

                                    console.log('data', e.data);
                                    navigate('/register', {
                                        state: e.data?.signInInfo,
                                    });
                                } catch (e: any) {
                                    if (e.data?.placeHolder || e.placeHolder) {
                                        toast.error(e.data?.placeHolder || e.placeHolder);
                                    } else {
                                        console.error(e);
                                    }
                                }
                            },
                            onClose: () => {
                                console.log('%c onClose-action', 'background-color:rgba(255,255,0,0.5);color:red;');
                            },
                            closeText: '나중에 할게요',
                            closeButtonProps: {
                                color: 'error',
                            },
                        });
                    } else {
                        setTemporaryToken(accessToken);
                        navigate('/register');
                    }

                    return;
                }

                toast.error(t('auth.loginFailed'));
                console.error(e);
            }
        }
    };

    const { social } = services;
    const {
        apple_client_id,
        apple_redirect_url,
        kakao_client_id,
        kakao_redirect_url,
        naver_client_id,
        naver_redirect_url,
    } = social;
    const naverHeaderUrl = 'https://nid.naver.com/oauth2.0/authorize';
    const kakaoHeaderUrl = 'https://kauth.kakao.com/oauth/authorize';
    const appleHeaderUrl = 'https://appleid.apple.com/auth/authorize';
    const naverURL = `${naverHeaderUrl}?response_type=code&client_id=${naver_client_id}&redirect_uri=${naver_redirect_url}&state=${refer}`;
    const kakaoURL = `${kakaoHeaderUrl}?response_type=code&client_id=${kakao_client_id}&redirect_uri=${kakao_redirect_url}&state=${refer}`;
    const appleURL = `${appleHeaderUrl}?response_type=code&client_id=${apple_client_id}&redirect_uri=${apple_redirect_url}&response_mode=form_post&scope=name&state=${refer}`;
    const socialLoginList: { text: string; color: any; href: string; img: any }[] = [
        { text: 'kakao', color: 'warning', href: kakaoURL, img: socialKakao },
        { text: 'naver', color: 'success', href: naverURL, img: socialNaver },
        { text: 'apple', color: 'black', href: appleURL, img: socialApple },
    ];

    return (
        <>
            <Helmet titleTemplate={`%s ${t('auth.login')}`} />
            <div className={'flex-1 flex items-center justify-center'}>
                <div>
                    <div className={'flex justify-center p-10'}>
                        {isFlowingSpaceDomain() ? (
                            <div
                                className={'text-center'}
                                style={{
                                    width: '100%',
                                    maxWidth: 300,
                                    marginTop: '-60px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                }}
                            >
                                <Link href={`${apiUrls.spacehome_url}/influencer`} target="_blank">
                                    <img
                                        src={sellerHookingLogo}
                                        style={{
                                            width: '40px',
                                            aspectRatio: '1 / 1',
                                            objectFit: 'cover',
                                            borderRadius: '10px',
                                        }}
                                        alt=""
                                    />
                                </Link>
                                <Typography variant="h2" fontWeight={500}>
                                    {t('auth.hookingspSeller')}
                                </Typography>
                            </div>
                        ) : (
                            <div
                                className={'text-center'}
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    maxWidth: 380,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Link
                                    href={`${apiUrls.spacehome_url}/influencer`}
                                    target="_blank"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <img
                                        src={soduBrandMark}
                                        style={{
                                            width: '66px',
                                            height: '66px',
                                            objectFit: 'contain',
                                        }}
                                        alt="소셜듀오 브랜드 마크"
                                    />
                                    <img
                                        src={soduWordmarkStack}
                                        style={{
                                            height: '56px',
                                            width: 'auto',
                                            objectFit: 'contain',
                                        }}
                                        alt="소셜 듀오"
                                    />
                                </Link>
                            </div>
                        )}
                    </div>
                    <Card
                        elevation={7}
                        sx={{
                            maxWidth: 380,
                            py: 3,
                            borderRadius: `30px`,
                        }}
                    >
                        <CardHeader title={t('auth.login')} />
                        <CardContent>
                            <form onSubmit={handleSubmit(signIn)}>
                                <FormTextField
                                    label={t('auth.email')}
                                    placeholder={'account@email.com'}
                                    name={'email'}
                                    form={form}
                                    rules={[(v) => !!v || t('auth.emailRequired')]}
                                    fullWidth
                                />
                                <FormTextField
                                    label={t('auth.password')}
                                    name={'password'}
                                    form={form}
                                    rules={[(v) => !!v || t('auth.passwordRequired')]}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position={'end'}>
                                                <IconButton
                                                    onClick={() => {
                                                        setIsPassView(!isPassView);
                                                    }}
                                                >
                                                    {isPassView ? <HideIcon /> : <ShowIcon />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    type={isPassView ? 'text' : 'password'}
                                    fullWidth
                                />
                                <div>
                                    <Button
                                        color={'primary'}
                                        size={'small'}
                                        sx={{ mb: 1 }}
                                        startIcon={<LockIcon />}
                                        onClick={() => {
                                            dialogOpen({
                                                innerElement: <ResetPassword email={getValues('email')} />,
                                            });
                                        }}
                                    >
                                        {t('auth.forgotPassword')}
                                    </Button>
                                </div>
                                <Button
                                    color={'primary'}
                                    variant={'contained'}
                                    size={'large'}
                                    type={'submit'}
                                    disabled={isSubmitting}
                                    fullWidth
                                >
                                    {isSubmitting ? t('common.loading') : t('auth.login')}
                                </Button>
                            </form>
                            <Divider sx={{ my: 3 }} />
                            {!isFlowingSpaceDomain() && (
                                <>
                                    <div className={'text-center mb-5'}>
                                        <Typography variant={'body1'}>{t('auth.notMemberYet')}</Typography>
                                    </div>
                                    <Typography variant="body2" gutterBottom textAlign={'center'}>
                                        {t('auth.easySnsLogin')}
                                    </Typography>
                                    <Grid container>
                                        <Grid xs={12} className="flex justify-center mt-5 gap-4">
                                            {socialLoginList.map((item, i) => {
                                                if (item.text === 'apple') return null;
                                                return (
                                                    <a
                                                        key={item.text + 'icon' + i}
                                                        className="cursor-pointer"
                                                        href={item.href}
                                                    >
                                                        <img
                                                            src={item.img}
                                                            style={{
                                                                aspectRatio: '1',
                                                                width: '50px',
                                                            }}
                                                            alt={`${item.text} ${t('auth.login')}`}
                                                        />
                                                    </a>
                                                );
                                            })}
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                            {/* <Divider sx={{ my: 1 }} /> */}

                            {!isFlowingSpaceDomain() && (
                                <div className={'text-center mt-5'}>
                                    <div>
                                        <Link href={`/register/sign-up`} typography={'caption'}>
                                            이메일로 회원가입하기! {'>>'}
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </CardContent>
                    </Card>
                </div>
            </div>
        </>
    );
};
